<div class="layout">
    <div class="logo-menu mt-3 mb-4">
        <img src="./assets/images/logos/logo_15.png" alt="logo_classind" />
    </div>
    <span *ngIf="!data['visualizacao']" data.mensagem class="mat-subheading-1 mt-2">{{data.mensagem?.pt}}</span>
    <span *ngIf="data['visualizacao']" data.mensagem class="mat-subheading-1">
        {{ 'TRADUCAO' | translate: data?.mensagem }}</span>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
